/************
 Product Size Chart
 ************/

document.querySelector(".productOptionSizeChartButton")?.addEventListener("click", function () {
    // open dialog
    document.querySelector("#productSizeChartDialog").showModal();
});

// close size chart dialog on outside click if target is not the inner part of dialog
document.querySelector("#productSizeChartDialog").addEventListener("click", function (event) {
    if (event.target === this) {
        this.close();
    }
});

// close size chart dialog on close button click
document.querySelector("#productSizeChartDialogFooterClose")?.addEventListener("click", function () {
    document.querySelector("#productSizeChartDialog").close();
});

/**************
 Product Variants
 ***************/

// update active variant on input changes
document.querySelectorAll("#product input, #product select").forEach(function (element) {
    element.addEventListener("change", function () {
        updateProduct();
    });
});

// update size dropdown
function updateSizeDropdown() {
    // get index of size option
    const sizeOptionIndex = product.options.indexOf("Size");

    // check if size option exists
    if (sizeOptionIndex === -1) {
        return;
    }

    // create set of sizes for unique values
    const sizes = new Set();

    // push sizes to set
    product.variants.map(variant => variant.options[sizeOptionIndex]).forEach(size => sizes.add(size));

    // previous selected size value
    const previousSelectedSize = document.querySelector(".productOptionSizeSelect[name='Size']").value;

    // clear size options
    document.querySelector(".productOptionSizeSelect[name='Size']").innerHTML = "";

    // append sizes to select
    sizes.forEach(size => {
        // create variant option array with the new size
        const variantOptionArray = activeVariant.options.toSpliced(sizeOptionIndex, 1, size);

        // find variant with the new size
        const foundVariant = product.variants.find(variant => JSON.stringify(variant.options) === JSON.stringify(variantOptionArray));

        // check if variant was found, if it was not found then skip that size option
        if (foundVariant === null || foundVariant === undefined) {
            return;
        }

        // create option
        const option = document.createElement("option");

        // set value
        option.value = size;

        // set text
        option.textContent = size;

        // append option
        document.querySelector(".productOptionSizeSelect[name='Size']").append(option);

        // check if variant is available
        if (!foundVariant.available) {
            // set disabled
            option.disabled = true;

            // set text content
            option.textContent = `${size} (Unavailable)`;
        }
    });

    // select previous size if it exists
    if (previousSelectedSize) {
        document.querySelector(".productOptionSizeSelect[name='Size']").value = previousSelectedSize;
    }
}

// update active variant
function updateProduct() {
    // collect options from inputs
    let options = [];
    document.querySelectorAll("#productOption [name]").forEach(function (element) {
        // if it's an input, it must be checked
        if (element.tagName === "INPUT" && !element.checked) {
            return;
        }

        options.push(element.value);
    });

    // find new variant based on the options
    activeVariant = product.variants.find((variant) => {
        return JSON.stringify(variant.options) === JSON.stringify(options)
    });

    // check if variant wasn't found
    if (activeVariant === null || activeVariant === undefined) {
        document.querySelector("#productATC").disabled = true;
        document.querySelector("#productATC").textContent = "Not Available";
        return;
    }

    // dispatch variant change event
    document.dispatchEvent(new CustomEvent("activeVariantChange"));

    // update price
    document.querySelector("#productPriceReal").textContent = price(activeVariant.price);
    const isSale = activeVariant.compare_at_price > activeVariant.price;
    if (isSale) {
        document.querySelector("#productPriceReal").classList.add("sale");
        document.querySelector("#productPriceCompare").textContent = price(activeVariant.compare_at_price);
    } else {
        document.querySelector("#productPriceReal").classList.remove("sale");
        document.querySelector("#productPriceCompare").textContent = "";
    }

    // afterpay
    try {
        // update display price
        document.querySelector('[data-mpid="1c2263bd-5c41-4bc7-9e5d-14c3b9335de6"]').dataset.amount = (activeVariant.price / 100);
    } catch (e) {
        console.error(e);
    }

    // check if the variant is in stock
    if (activeVariant.available) {
        document.querySelector("#productATC").classList.add("primary");
        document.querySelector("#productATC").disabled = false;
        document.querySelector("#productATC").textContent = "Add To Cart";
    } else {
        document.querySelector("#productATC").classList.remove("primary");
        document.querySelector("#productATC").disabled = true;
        document.querySelector("#productATC").textContent = "Sold Out";
    }

    // update size dropdown
    updateSizeDropdown();

    // update url with variant id so the selected options are maintained on refresh
    let url = new URL(window.location.href);
    url.searchParams.set("variant", activeVariant.id);
    window.history.replaceState({}, "", url);
}

/****************
 * Product Quantity
 */

let quantity = 1;

/**************
 Product ATC
 ***************/

document.querySelector("#productATC").addEventListener("click", async function () {
    // set atc items
    let items;

    // add loading animation
    this.classList.add("loading");

    // Set items to B2B items if dealer site
    items = [{
        quantity: quantity,
        id: activeVariant.id,
    }];


    let formData = {
        items: items
    };

    // add product
    await addProduct(formData);

    // remove loading animation
    this.classList.remove("loading");

    // open cart
    await openCart();
});


updateProduct();